import * as React from "react"

const MapPinGear = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.8 55.47" {...props}>
    <title>{"parcel-journey-6-map-pin-gear-icon-2"}</title>
    <path
      d="M38.8 19.44a19.4 19.4 0 1 0-36.91 8.31C8 41.85 19.4 55.47 19.4 55.47s11.43-13.62 17.54-27.72a19.29 19.29 0 0 0 1.86-8.31Zm-8.8 2a11.63 11.63 0 0 1-1 2.27l1.35 1.66-4 4-1.66-1.33a11.85 11.85 0 0 1-2.24.92l-.21 2.14h-5.73l-.21-2.14a12 12 0 0 1-2.23-.92l-1.66 1.35-4.05-4 1.36-1.66a10.67 10.67 0 0 1-.92-2.24l-2.14-.21v-5.75l2.14-.21a10.59 10.59 0 0 1 .92-2.23l-1.36-1.66 4.05-4.05 1.66 1.36a10.59 10.59 0 0 1 2.23-.92l.21-2.14h5.73l.21 2.14a10.67 10.67 0 0 1 2.24.92l1.66-1.36 4 4.05L29 13.09a11.43 11.43 0 0 1 1 2.23l2.14.21v5.73Zm-10.62-7.79a4.75 4.75 0 1 0 4.74 4.76 4.75 4.75 0 0 0-4.74-4.76Z"
      fill="#4ead90"
    />
  </svg>
)

export default MapPinGear
